export default __webpack_public_path__ + "static/media/coin-loss.5c82622e.wav";